export const langData = (lng, Data) => {
    return lng === "jp" ? Data.jp : Data.en;
}

export const getUa = () => {
    const ua = navigator.userAgent;
    if (["iPhone", "iPod", "Android", "Windows Phone"].map((u) => { return ua.indexOf(u) }).reduce(function (sum, element) {
        return sum + element;
    }, 0) > 0)
        return "sp";
    else
        return "pc";
}